import { privacyPageService } from '../network/services/privacy-page.service';
import { ResponseError } from '../network/response/response-error';

export default {
  namespaced: true,
  state: {
    loading: false,
    titles: [],
    items: [],
    exports: false,
    forget: false,
    exportsResponse: [],
    forgetsResponse: [],
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = !!payload;
    },
    SET_ITEMS(state, payload) {
      state.items = payload;
    },
    SET_EXPORTS(state, payload) {
      state.exports = !!payload;
    },
    SET_FORGET(state, payload) {
      state.forget = !!payload;
    },
    SET_EXPORTS_RESPONSE(state, payload) {
      state.exportsResponse = payload
    },
    SET_FORGETS_RESPONSE(state, payload) {
      state.forgetsResponse = payload
    }
  },
  actions: {
    async fetch(context, { lang }) {
      context.commit('SET_LOADING', true);
      const responseItem = await privacyPageService.fetch({ lang });
      const item = responseItem.get('Privacy.many', [] );

      if(item instanceof ResponseError) {
        // TODO catch errors
      } else {
        context.commit('SET_ITEMS', item);
      }
      context.commit('SET_LOADING', false);
    },

    async exportRequest(context) {
      context.commit('SET_LOADING', true);
      const responseRequest = await privacyPageService.exportRequest(context.rootState.client.tokens.accessToken);
      const request = await responseRequest.get('Privacy.exports.createRequest', []);
      if(request instanceof ResponseError) {
        // TODO errors exceptions
      } else {
        context.commit('SET_EXPORTS', true);
        context.commit('SET_EXPORTS_RESPONSE', request);
        context.commit('SET_LOADING', false);
        return request;
      }
    },

    async forgetRequest(context) {
      context.commit('SET_LOADING', true);
      const responseRequest = await privacyPageService.forgetRequest(context.rootState.client.tokens.accessToken);
      const request = await responseRequest.get('Privacy.forgets.createRequest', []);
      if(request instanceof ResponseError) {
        // TODO errors exceptions
      } else {
        context.commit('SET_FORGET', true);
        context.commit('SET_FORGETS_RESPONSE', request);
        context.commit('SET_LOADING', false);
        return request;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/stores/privacy-page.store.js